import React, { useState } from 'react'

import { Flex, Grid, Image, Text, VStack } from '@chakra-ui/react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { GetDriverLicense } from '@core/app/types/profileApiType'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'

import a from '@page/profile/assets/images/license/a.svg'
import a1 from '@page/profile/assets/images/license/a1.svg'
import b from '@page/profile/assets/images/license/b.svg'
import be from '@page/profile/assets/images/license/be.svg'
import c from '@page/profile/assets/images/license/c.svg'
import c1 from '@page/profile/assets/images/license/c1.svg'
import c1e from '@page/profile/assets/images/license/c1e.svg'
import ce from '@page/profile/assets/images/license/ce.svg'
import d from '@page/profile/assets/images/license/d.svg'
import d1 from '@page/profile/assets/images/license/d1.svg'
import d1e from '@page/profile/assets/images/license/d1e.svg'
import de from '@page/profile/assets/images/license/de.svg'
import forklift from '@page/profile/assets/images/license/forklift.svg'
import m from '@page/profile/assets/images/license/m.svg'
import s from '@page/profile/assets/images/license/s.svg'
import tt from '@page/profile/assets/images/license/t.svg'

import './ApplyV2ReviewApplyDriverLicense.scss'

interface Props {
    className?: string
    isShowExpandButton?: boolean
}

const baseClass = 'ApplyV2ReviewApplyDriverLicense'
function ApplyV2ReviewApplyDriverLicense({ className }: Props) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const { t, i18n } = useTranslation()
    const [licenses, setLicenses] = useState<{ id: number; name: string; checked: boolean }[]>([
        { id: 1, name: 'A1', checked: false },
        { id: 5, name: 'A', checked: false },
        { id: 8, name: 'B', checked: false },
        { id: 17, name: `B (${t('8681')})`, checked: false },
        { id: 9, name: 'BE', checked: false },
        { id: 11, name: 'C1', checked: false },
        { id: 12, name: 'C1E', checked: false },
        { id: 14, name: 'C', checked: false },
        { id: 15, name: 'CE', checked: false },
        { id: 2, name: 'D1', checked: false },
        { id: 3, name: 'D1E', checked: false },
        { id: 6, name: 'D', checked: false },
        { id: 7, name: 'DE', checked: false },
        { id: 10, name: 'M', checked: false },
        { id: 13, name: 'S', checked: false },
        { id: 4, name: i18n.language === 'da' ? 'TR/MR' : 'T', checked: false },
        { id: 16, name: `${t('7687')}`, checked: false },
    ])

    const data = postProfileData?.data?.driverLicence || []

    const getImageById = (id: number) => {
        switch (id) {
            case 1:
                return a1
            case 2:
                return d1
            case 3:
                return d1e
            case 4:
                return tt
            case 5:
                return a
            case 6:
                return d
            case 7:
                return de
            case 8:
                return b
            case 9:
                return be
            case 10:
                return m
            case 11:
                return c1
            case 12:
                return c1e
            case 13:
                return s
            case 14:
                return c
            case 15:
                return ce
            case 16:
                return forklift
            case 17:
                return b
        }
    }
    const isEmpty = !data || data.length === 0 || data.includes(66)
    const noFields = data && data.includes(66)

    return (
        // <div className={`${baseClass} ${className}`}>
        <div
            className={clsx(baseClass, className, {
                [`${baseClass}--isEmpty`]: isEmpty || noFields,
            })}
        >
            {noFields ? (
                <div>{t('10307', "I don't have a driver's license")}</div>
            ) : isEmpty ? (
                <div>{t('10698', 'No driver’s license added')}</div>
            ) : (
                data.map((item: number) => (
                    <VStack key={item}>
                        <Image src={getImageById(item)} />
                        <Text fontSize={'sm'} fontWeight={'semibold'} color={'text.secondary'}>
                            {licenses.map((license) => {
                                if (license.id === item) {
                                    return license.name
                                }
                            })}
                        </Text>
                    </VStack>
                ))
            )}
            {/*{data.map((item: number) => (*/}
            {/*    <VStack key={item}>*/}
            {/*        <Image src={getImageById(item)} />*/}
            {/*        <Text fontSize={'sm'} fontWeight={'semibold'} color={'text.secondary'}>*/}
            {/*            {licenses.map((license) => {*/}
            {/*                if (license.id === item) {*/}
            {/*                    return license.name*/}
            {/*                }*/}
            {/*            })}*/}
            {/*        </Text>*/}
            {/*    </VStack>*/}
            {/*))}*/}
        </div>
    )
}

export default ApplyV2ReviewApplyDriverLicense
